var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.001 8.125V11.25",
    stroke: "red",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92333 3.12495L2.04833 15C1.93881 15.1897 1.88105 15.4048 1.88086 15.6239C1.88067 15.8429 1.93804 16.0582 2.04723 16.248C2.15642 16.4379 2.31359 16.5958 2.503 16.7058C2.69241 16.8159 2.90741 16.8742 3.12646 16.875H16.8765C17.0955 16.8742 17.3105 16.8159 17.4999 16.7058C17.6893 16.5958 17.8465 16.4379 17.9557 16.248C18.0649 16.0582 18.1222 15.8429 18.1221 15.6239C18.1219 15.4048 18.0641 15.1897 17.9546 15L11.0796 3.12495C10.9709 2.93501 10.8139 2.77715 10.6246 2.66736C10.4353 2.55758 10.2203 2.49976 10.0015 2.49976C9.7826 2.49976 9.56764 2.55758 9.37831 2.66736C9.18899 2.77715 9.03203 2.93501 8.92333 3.12495V3.12495Z",
    stroke: "red",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.001 14.6875C10.3462 14.6875 10.626 14.4077 10.626 14.0625C10.626 13.7173 10.3462 13.4375 10.001 13.4375C9.6558 13.4375 9.37598 13.7173 9.37598 14.0625C9.37598 14.4077 9.6558 14.6875 10.001 14.6875Z",
    fill: "red"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedWarning);
export default __webpack_public_path__ + "static/media/RedWarning.4f4a56bab97121a01ceea6cb7613f8f4.svg";
export { ForwardRef as ReactComponent };